import throttle from 'lodash.throttle'

export default {
  inserted: function(el, { value }) {
    let currentWidth,
      maxWidth,
      minWidth,
      oneWidth,
      newWidthInColumns,
      initialPos = null,
      down = false,
      prevColumn = null

    el.onmousedown = e => {
      down = true

      if (e.button !== 0) {
        return
      }

      initialPos = e.pageX

      currentWidth = el.parentElement.clientWidth
      maxWidth = el.parentElement.parentElement.clientWidth
      oneWidth = parseInt(maxWidth / 12, 10)
      minWidth = oneWidth * 2

      newWidthInColumns = Math.round(currentWidth / minWidth)

      el.dataset.width = newWidthInColumns
      el.dataset.show = true
      el.parentElement.dataset.resizing = true

      document.onmousemove = throttle(e => {
        document.body.style.cursor = down ? 'col-resize' : ''

        let diff = e.pageX - initialPos

        if (diff > 0 && diff + currentWidth > maxWidth) {
          diff = maxWidth - currentWidth
        } else if (diff < 0 && currentWidth + diff < minWidth) {
          diff = minWidth - currentWidth
        }

        newWidthInColumns = Math.round((currentWidth + diff) / oneWidth)

        el.dataset.width = newWidthInColumns

        if (!prevColumn) {
          prevColumn = newWidthInColumns
        }

        if (newWidthInColumns !== prevColumn) {
          value(newWidthInColumns)

          prevColumn = newWidthInColumns
        }
      }, 300)

      document.onmouseup = () => {
        document.body.style.cursor = 'default'
        down = false

        el.parentElement.dataset.resizing = false

        value(newWidthInColumns <= 2 ? 2 : newWidthInColumns)

        el.dataset.show = false

        document.onmousemove = null
        document.onmouseup = null
      }
    }
  },
}
